import { forEach, toString } from 'lodash';

const TO_BE_STRINGIFIED = {
    combinedSpecialtyProcedure: ['specialtyId', 'procedureId'],
    doctors: ['id'],
    procedures: ['specialtyId', 'procedureId'],
    semantic: ['specialtyId', 'procedureId'],
    specialties: ['specialtyId', 'procedureId'],
};

/**
 * Takes in an API response from autocomplete and modifies it in-place to stringify
 * incoming IDs.
 */
export default function stringifyIdsInAPIResponse(data) {
    forEach(data, (value, key) => {
        if (TO_BE_STRINGIFIED[key]) {
            data[key] = data[key].map(item => {
                forEach(item, (subval, subkey) => {
                    if (TO_BE_STRINGIFIED[key].includes(subkey)) {
                        item[subkey] = toString(item[subkey]);
                    }
                });

                return item;
            });
        }
    });

    return data;
}
